import { Injectable } from 'angular-ts-decorators';

@Injectable('productDifferencesToggleService')
export class ProductDifferencesToggleService {
  public static $inject: ReadonlyArray<string> = [];

  public isToggleOn = false;
}
